export const classes = {
  wrapper: 'flex w-full h-full justify-center items-center mt-12',
  message: 'text-xl text-grey-5 font-normal',
};
